/**
 * Custom Measurements — single-submit inquiry (email + WhatsApp)
 * -----------------------------------------------------------------------
 * Triggered by the "Customize Your Size" value in the product's Size
 * option: selecting it reveals the measurement panel, selecting any
 * normal size hides it again.
 *
 * PURCHASE LOCK (05-10-2026): while a "Customize Your Size" variant is
 * selected the product must NOT be purchasable. This script now:
 *   - hides the in-page CTAs (via body.cm-custom-active CSS in
 *     snippets/custom-measurements-fields.liquid) AND the fixed bottom
 *     bar from snippets/adhive-sticky-atc.liquid (.adhv-sbar), which the
 *     old CSS missed — hiding .cta-stack made that bar slide in, and its
 *     buttons proxied to the real Add to cart / Shiprocket Buy now.
 *   - disables the real Add to cart button (the fixed bar mirrors it).
 *   - blocks, in the capture phase, any click on Add to cart / Buy now /
 *     sticky buttons and any submit of the product form whenever the
 *     selected variant is a Customize variant — so no other script can
 *     add it to the cart or start a checkout from this page.
 *   - (v2) network lock: every /cart/add request (fetch + XHR) carrying a
 *     Customize variant is refused, whichever section sent it (CTA bands,
 *     Final CTA, Core Pair, quick-adds). Customize lines that still reach
 *     the cart are removed, and any already in the cart are purged on load.
 *   - (v2) CTA band / Final CTA buttons read "Submit Your Measurements"
 *     and scroll to the form while Customize is selected.
 * Normal sizes are untouched: everything is gated on the Customize
 * variant being the one currently selected.
 *
 * On submit, one click does two things:
 *   1. POSTs to Shopify's native contact form (/contact).
 *   2. Opens WhatsApp pre-filled with the same details.
 *
 * No Shopify cart or order is created by this script.
 */
(function () {
  "use strict";

  var WHATSAPP_NUMBER = "919818600678"; // +91 98186 00678
  var CUSTOM_PREFIX = "Customize"; // matches "Customize Your Size"

  // ---- variant lookup (same JSON the hero section renders) ----
  var VARIANTS = null;
  function variantsMap() {
    if (VARIANTS) return VARIANTS;
    VARIANTS = {};
    var tag = document.querySelector('script[id^="adhiveVariants-"]');
    if (tag) {
      try {
        JSON.parse(tag.textContent || "[]").forEach(function (v) {
          VARIANTS[String(v.id)] = v;
        });
      } catch (e) {}
    }
    return VARIANTS;
  }
  function isCustomValue(value) {
    return String(value || "").indexOf(CUSTOM_PREFIX) > -1;
  }
  function selectedIsCustom() {
    if (document.body && document.body.classList.contains("cm-custom-active")) return true;
    var inp = document.querySelector("form.adhive-atc-form [data-variant-id]") ||
              document.querySelector("form.adhive-atc-form input[name='id']");
    if (!inp || !inp.value) return false;
    var v = variantsMap()[String(inp.value)];
    if (!v) return false;
    if (isCustomValue(v.title)) return true;
    return (v.options || []).some(isCustomValue);
  }

  // ---- CSS: hide the fixed bars too (the snippet CSS only covers the buy box) ----
  (function injectStyle() {
    if (document.getElementById("cm-lock-style")) return;
    var css =
      "body.cm-custom-active .adhv-sbar," +
      "body.cm-custom-active .sticky-cart{display:none!important}" +
      "body.cm-custom-active.adhv-sbar-pad{padding-bottom:0!important}";
    var s = document.createElement("style");
    s.id = "cm-lock-style";
    s.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(s);
  })();

  // ---- hard guard: capture phase on window runs before every other handler ----
  var STICKY_SEL = "[data-sbar-atc],[data-sbar-buy],[data-sticky-add]";
  var BUYBOX_SEL =
    "[data-add],button[name='add'],.shopify-payment-button,.shopify-payment-button__button," +
    "[class*='shiprocket'],[id*='shiprocket'],[class*='Shiprocket'],[class*='gokwik'],[id*='gokwik']";

  function nudge() {
    var panel = document.querySelector("[data-cm-inline]");
    if (!panel) return;
    try { panel.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e) {}
    var first = panel.querySelector("[data-cm-required]");
    if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 350);
  }

  function block(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    nudge();
  }

  window.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest || t.closest("[data-cm-inline]")) return;
    var hit = t.closest(STICKY_SEL) ||
              (t.closest("#adhive-buy") && t.closest(BUYBOX_SEL));
    if (hit && selectedIsCustom()) block(e);
  }, true);

  window.addEventListener("submit", function (e) {
    var f = e.target;
    if (f && f.matches && f.matches("form.adhive-atc-form") && selectedIsCustom()) block(e);
  }, true);

  // Enter key inside the measurement inputs must not submit the product form
  window.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && e.target && e.target.closest &&
        e.target.closest("[data-cm-inline]") && e.target.tagName !== "TEXTAREA") {
      e.preventDefault();
    }
  }, true);

  // ---- NETWORK-LEVEL LOCK ------------------------------------------------
  // Other PDP sections (CTA bands, Final CTA, Core Pair, quick-adds) call
  // /cart/add.js themselves with the selected variant id, bypassing the buy
  // box. Every /cart/add request (fetch or XHR) is therefore checked here:
  //   1. before sending: if the payload contains a Customize variant id from
  //      this product, the request is refused (HTTP 422, nothing is sent);
  //   2. after a fetch add succeeds: if the added line is a Customize
  //      variant of ANY product (e.g. a quick-add of another product), it is
  //      removed from the cart again and the caller gets a 422.
  // On load, any Customize line already sitting in the cart is removed.
  var _origFetch = window.fetch ? window.fetch.bind(window) : null;
  var LOCK_MSG = "Customize Your Size can't be added to cart. Please submit your measurements and our team will confirm pricing.";

  function customIdSet() {
    var map = variantsMap(), set = {};
    Object.keys(map).forEach(function (id) {
      var v = map[id];
      if (isCustomValue(v.title) || (v.options || []).some(isCustomValue)) set[id] = true;
    });
    return set;
  }

  function idsFromBody(body) {
    var ids = [];
    if (!body) return ids;
    function pushPairs(entries) {
      entries.forEach(function (kv) {
        var k = String(kv[0]);
        if (k === "id" || /^items\[\d*\]\[id\]$/.test(k)) ids.push(String(kv[1]));
      });
    }
    try {
      if (typeof FormData !== "undefined" && body instanceof FormData) {
        var fe = []; body.forEach(function (v, k) { fe.push([k, v]); }); pushPairs(fe);
      } else if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
        var ue = []; body.forEach(function (v, k) { ue.push([k, v]); }); pushPairs(ue);
      } else if (typeof body === "string") {
        var s = body.trim();
        if (s.charAt(0) === "{" || s.charAt(0) === "[") {
          var o = JSON.parse(s);
          if (o && o.id) ids.push(String(o.id));
          (o && o.items || []).forEach(function (it) { if (it && it.id) ids.push(String(it.id)); });
        } else {
          var pe = []; new URLSearchParams(s).forEach(function (v, k) { pe.push([k, v]); }); pushPairs(pe);
        }
      }
    } catch (e) {}
    return ids;
  }

  function payloadIsCustom(body) {
    var set = customIdSet();
    return idsFromBody(body).some(function (id) { return set[id]; });
  }

  function itemIsCustom(it) {
    if (!it) return false;
    if (isCustomValue(it.variant_title) || isCustomValue(it.title) || isCustomValue(it.sku)) return true;
    return (it.variant_options || []).some(isCustomValue);
  }

  function removeLines(items) {
    if (!_origFetch) return Promise.resolve();
    return items.reduce(function (p, it) {
      return p.then(function () {
        return _origFetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({ id: it.key, quantity: 0 })
        }).catch(function () {});
      });
    }, Promise.resolve());
  }

  function lockedResponse() {
    nudge();
    return new Response(
      JSON.stringify({ status: 422, message: "Cart Error", description: LOCK_MSG }),
      { status: 422, headers: { "Content-Type": "application/json" } }
    );
  }

  function isAddUrl(u) { return String(u || "").indexOf("/cart/add") > -1; }

  if (_origFetch && !window.__cmLockFetch) {
    window.__cmLockFetch = true;
    var _prevFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      if (!isAddUrl(url)) return _prevFetch.apply(this, arguments);
      if (payloadIsCustom(init && init.body)) return Promise.resolve(lockedResponse());
      return _prevFetch.apply(this, arguments).then(function (res) {
        if (!res || !res.ok) return res;
        return res.clone().json().then(function (data) {
          var items = data && data.items ? data.items : (data && data.key ? [data] : []);
          var bad = items.filter(itemIsCustom);
          if (!bad.length) return res;
          return removeLines(bad).then(lockedResponse);
        }).catch(function () { return res; });
      });
    };
  }

  if (window.XMLHttpRequest && !window.__cmLockXhr) {
    window.__cmLockXhr = true;
    var _xOpen = XMLHttpRequest.prototype.open;
    var _xSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) {
      this.__cmIsAdd = isAddUrl(u);
      return _xOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (this.__cmIsAdd && payloadIsCustom(body)) {
        nudge();
        try { this.abort(); } catch (e) {}
        return;
      }
      return _xSend.apply(this, arguments);
    };
  }

  // Remove any Customize line already in the cart (e.g. added before this fix)
  function purgeCart() {
    if (!_origFetch) return;
    _origFetch("/cart.js?_=" + Date.now(), { headers: { Accept: "application/json" }, credentials: "same-origin", cache: "no-store" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bad = (cart && cart.items || []).filter(itemIsCustom);
        if (!bad.length) return;
        return removeLines(bad).then(function () {
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
          document.dispatchEvent(new CustomEvent("adhive:cart-updated"));
        });
      })
      .catch(function () {});
  }
  purgeCart();

  // CTA bands / Final CTA: relabel + redirect to the measurement form
  var CTA_SEL = "[id^='adhiveBandBtn-'],[id^='adhiveFctaBtn-'],.fcta-btn,.miniband .btn";
  window.addEventListener("click", function (e) {
    var t = e.target;
    if (t && t.closest && t.closest(CTA_SEL) && selectedIsCustom()) block(e);
  }, true);
  function relabelCtas(on) {
    document.querySelectorAll(CTA_SEL).forEach(function (b) {
      if (!b.hasAttribute("data-cm-orig")) b.setAttribute("data-cm-orig", b.textContent.trim());
      b.textContent = on ? "Submit Your Measurements" : b.getAttribute("data-cm-orig");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    var panel = document.querySelector("[data-cm-inline]");
    if (!panel || panel.dataset.cmInitialized) return;
    panel.dataset.cmInitialized = "1";

    var heroForm = document.querySelector("form.adhive-atc-form");
    var ctaStack = heroForm ? heroForm.querySelector(".cta-stack") : null;
    var addBtn = heroForm ? heroForm.querySelector("[data-add]") : null;
    var sizesGroup = document.querySelector(".adhv-wrap .sizes");

    // Position the panel just above the buy buttons.
    if (heroForm) {
      if (ctaStack && ctaStack.parentNode === heroForm) {
        heroForm.insertBefore(panel, ctaStack);
      } else {
        heroForm.appendChild(panel);
      }
    }

    var requiredInputs = panel.querySelectorAll("[data-cm-required]");
    var errorEl = panel.querySelector("[data-cm-error]");
    var successEl = panel.querySelector("[data-cm-success]");
    var submitBtn = panel.querySelector("[data-cm-submit]");
    var productTitle = panel.dataset.productTitle || "Product";
    var productUrl = panel.dataset.productUrl || "";

    function setEnabled(enabled) {
      document.body.classList.toggle("cm-custom-active", enabled);
      panel.hidden = !enabled;
      panel.querySelectorAll("input, textarea, button").forEach(function (el) {
        el.disabled = !enabled;
      });
      // Real Add to cart is disabled while Customize is selected; the fixed
      // bar mirrors this button. When a normal size is picked the hero
      // section's own render() restores the correct state.
      if (enabled && addBtn) addBtn.disabled = true;
      relabelCtas(enabled);
      errorEl.hidden = true;
      successEl.hidden = true;
    }

    if (sizesGroup) {
      sizesGroup.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-value]");
        if (!btn) return;
        var on = isCustomValue(btn.getAttribute("data-value"));
        setEnabled(on);
        // run again after the hero's own click handler, whichever fires first
        setTimeout(function () { if (on && addBtn) addBtn.disabled = true; }, 0);
      });

      var active = sizesGroup.querySelector("[data-value].active");
      setEnabled(!!(active && isCustomValue(active.getAttribute("data-value"))) || selectedIsCustom());
    } else {
      setEnabled(false);
    }

    function fieldValue(idPrefix) {
      var el = panel.querySelector("[id^='" + idPrefix + "-']");
      return el ? el.value.trim() : "";
    }

    function validate() {
      errorEl.hidden = true;
      var missing = Array.prototype.filter.call(requiredInputs, function (el) {
        return el.value.trim() === "";
      });
      if (missing.length) {
        errorEl.textContent =
          "Please fill in all required fields marked with * to continue.";
        errorEl.hidden = false;
        missing[0].focus();
        return false;
      }
      var email = fieldValue("cmEmail");
      if (email.indexOf("@") === -1 || email.indexOf(".") === -1) {
        errorEl.textContent = "Please enter a valid email address.";
        errorEl.hidden = false;
        return false;
      }
      return true;
    }

    function buildMessage() {
      var lines = [];
      lines.push("CUSTOM SIZE REQUEST");
      lines.push(productTitle);
      if (productUrl) lines.push(productUrl);
      lines.push("");
      lines.push("Bust: " + fieldValue("cmBust") + " in");
      lines.push("Waist: " + fieldValue("cmWaist") + " in");
      lines.push("Hips: " + fieldValue("cmHips") + " in");
      var shoulder = fieldValue("cmShoulder");
      var length = fieldValue("cmLength");
      var sleeve = fieldValue("cmSleeve");
      if (shoulder) lines.push("Shoulder: " + shoulder + " in");
      if (length) lines.push("Full Length: " + length + " in");
      if (sleeve) lines.push("Sleeve Length: " + sleeve + " in");
      var notes = fieldValue("cmNotes");
      if (notes) {
        lines.push("");
        lines.push("Notes: " + notes);
      }
      lines.push("");
      lines.push("Name: " + fieldValue("cmName"));
      lines.push("WhatsApp: " + fieldValue("cmPhone"));
      lines.push("Email: " + fieldValue("cmEmail"));
      return lines.join("\n");
    }

    function sendEmail(message) {
      var params = new URLSearchParams();
      params.append("form_type", "contact");
      params.append("utf8", "\u2713");
      params.append("contact[name]", fieldValue("cmName"));
      params.append("contact[email]", fieldValue("cmEmail"));
      params.append("contact[phone]", fieldValue("cmPhone"));
      params.append("contact[body]", message);
      return fetch("/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "text/html",
        },
        body: params.toString(),
      });
    }

    if (submitBtn) {
      submitBtn.addEventListener("click", function () {
        if (!validate()) return;

        var message = buildMessage();
        var originalLabel = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = "Sending\u2026";

        // Open WhatsApp synchronously inside the click handler — opening
        // it later (in a .then) gets blocked as a popup.
        var waWindow = window.open(
          "https://wa.me/" +
            WHATSAPP_NUMBER +
            "?text=" +
            encodeURIComponent(message),
          "_blank"
        );

        sendEmail(message)
          .then(function () {
            successEl.textContent = waWindow
              ? "Sent! Our team has your measurements by email. WhatsApp has also opened with your details \u2014 tap send there so we can reply to you faster."
              : "Sent! Our team has your measurements by email and will get back to you shortly.";
            successEl.hidden = false;
            submitBtn.textContent = "Measurements Sent \u2713";
          })
          .catch(function () {
            errorEl.textContent =
              "We couldn't send the email automatically. Please use the WhatsApp window that just opened, or write to help@prettypixie.com.";
            errorEl.hidden = false;
            submitBtn.disabled = false;
            submitBtn.textContent = originalLabel;
          });
      });
    }
  }
})();
